import React from 'react';
import ReadOnlyBadge from './ReadOnlyBadge';

export interface InputFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  iconLeft?: React.ReactNode;
  iconRight?: React.ReactNode;
  containerClassName?: string;
  inputClassName?: string;
  error?: string;
  readOnly?: boolean;
  showReadOnlyBadge?: boolean;
}

/**
 * Reusable input field component with optional label, left/right icons, and error display.
 * Applies shared form styles and supports all native input props.
 */
export const InputField = React.forwardRef<HTMLInputElement, InputFieldProps>(
  (
    {
      label,
      iconLeft,
      iconRight,
      containerClassName = '',
      inputClassName = '',
      error,
      type = 'text',
      readOnly = false,
      showReadOnlyBadge = false,
      ...props
    },
    ref
  ) => {
    return (
      <div className={`formInputContainer ${containerClassName}`.trim()}>
        {label && (
          <label className="formLabel">
            {label}
            {props.required && <span className="text-destructive">*</span>}
          </label>
        )}        <div className="relative">
          {iconLeft && (
            <span className="formInputIcon formInputIconLeft">{iconLeft}</span>
          )}          <input
            ref={ref}
            type={type}
            readOnly={readOnly}
            className={`formInput${iconLeft ? ' formInputWithIconLeft' : ''}${iconRight ? ' formInputWithIconRight' : ''}${props.required ? ' formInputRequiredBg' : ''}${error ? ' formInputErrorBg' : ''}${readOnly ? ' formInputReadOnly form-input-readonly' : ''}${inputClassName ? ' ' + inputClassName : ''}`.trim()}
            {...props}
          />
          {iconRight && (
            <span className="formInputIcon formInputIconRight">{iconRight}</span>
          )}
          {readOnly && showReadOnlyBadge && <ReadOnlyBadge />}
        </div>
        {error && <div className="formError mt-1">{error}</div>}
      </div>
    );
  }
);

InputField.displayName = 'InputField';

export default InputField;
